import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqData } from '../data/mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-[#0F0F11]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-neutral-400">
              Got questions? We've got answers. Can't find what you're looking for? Give us a call!
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="bg-[#050505] border border-white/10 rounded-3xl shadow-lg p-8">
            <Accordion type="single" collapsible className="space-y-4">
              {faqData.map((faq, index) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`}
                  className="bg-[#0F0F11] rounded-xl border border-white/10 px-6 data-[state=open]:border-[#D4AF37] transition-all"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-[#D4AF37] py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-neutral-400 text-base pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-12">
            <p className="text-lg text-neutral-300 mb-4">
              Still have questions?
            </p>
            <a 
              href="tel:306-262-5995" 
              className="inline-block text-2xl font-bold text-[#D4AF37] hover:text-[#F0C84A] underline decoration-2 underline-offset-4 transition-colors"
            >
              Call us at 306-262-5995
            </a>
            <p className="text-neutral-400 mt-2">We're here to help 24/7</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
